// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/heading-4.js';

import { paths } from '../generated/heading-4';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('heading-4', Original, paths);
